export default __webpack_public_path__ + "static/media/Thi-34.670e8e6c.svg";